import { useState } from 'react';
import { Box, Typography, Radio, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from '@mui/icons-material/Add';
import ModalDireccion from '../modals/ModalDireccion';

const AddressOption = ({ id, title, subtitle, isSelected, onSelect }) => (
  <Paper
    elevation={0}
    onClick={() => onSelect(id)}
    sx={{
      p: 2.5,
      borderRadius: '16px',
      border: '1px solid',
      borderColor: isSelected ? 'secondary.main' : 'sutil',
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      mb: 2,
      cursor: 'pointer',
      bgcolor: 'white',
      transition: 'all 0.2s',
      '&:hover': { borderColor: 'secondary.main', bgcolor: 'grey.50' }
    }}
  >
    {/* «Nueva dirección» no se elige: abre la ventana para agregarla */}
    {id !== 'new' && (
      <Radio
        checked={isSelected}
        sx={{ p: 0, color: 'divider', '&.Mui-checked': { color: 'secondary.main' } }}
      />
    )}
    <Box sx={{
      width: 44,
      height: 44,
      borderRadius: '12px',
      bgcolor: (t) => alpha(t.palette.secondary.main, 0.1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'primary.main'
    }}>
      {id === 'new' ? <AddIcon /> : <HomeIcon />}
    </Box>
    <Box sx={{ flex: 1 }}>
      <Typography variant="subtitle2" fontWeight="900" color="primary.main">{title}</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500, display: 'block', mt: 0.5 }}>{subtitle}</Typography>
    </Box>
  </Paper>
);

// Dirección de un servicio a domicilio: una de las guardadas en el perfil (la reserva manda su id y el servidor guarda una foto).
// Una nueva se agrega con la misma ventana del formulario de páginas: queda en el perfil y se elige sola.
const BookingAddress = ({
  addresses,
  selectedAddressId, setSelectedAddressId,
  error = false
}) => {
  const [agregando, setAgregando] = useState(false);

  return (
    <Box sx={{ p: 4, borderRadius: '24px', bgcolor: 'white', border: '1px solid', borderColor: error ? 'error.main' : 'sutil' }}>
      <Typography variant="h6" fontWeight="900" color="primary.main" sx={{ mb: error ? 1 : 4 }}>
        Dirección de servicio
      </Typography>
      {error && (
        <Typography variant="body2" color="error.oscuro" sx={{ mb: 3 }}>
          Elige o agrega la dirección donde será el servicio.
        </Typography>
      )}

      {addresses.length > 0 && (
        <>
          <Typography variant="caption" color="text.secondary" fontWeight="900" sx={{ display: 'block', mb: 2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            TUS DIRECCIONES
          </Typography>
          {addresses.map((addr) => (
            <AddressOption
              key={addr._id}
              id={addr._id}
              title={addr.nombre}
              subtitle={addr.direccion}
              isSelected={selectedAddressId === addr._id}
              onSelect={setSelectedAddressId}
            />
          ))}
        </>
      )}

      <Typography variant="caption" color="text.secondary" fontWeight="900" sx={{ display: 'block', mt: addresses.length > 0 ? 3 : 0, mb: 2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        AGREGAR NUEVA DIRECCIÓN
      </Typography>
      <AddressOption
        id="new"
        title="Nueva dirección"
        subtitle="Se guarda en tu perfil para usarla después"
        isSelected={false}
        onSelect={() => setAgregando(true)}
      />

      <ModalDireccion
        open={agregando}
        onClose={() => setAgregando(false)}
        onSaved={(nueva) => setSelectedAddressId(nueva._id)}
      />
    </Box>
  );
};

export default BookingAddress;
